import config from './config'
import { LoadScripts } from './utils/scriptLoader'

export function initSlaask(info, isSupport, callBackMessage) {
  const {
    id,
    name = '',
    lastName = '',
    email = '',
    userId = '',
    userCode = '',
    managerName = ''
  } = info
  const settings = isSupport
    ? {
      identify: () => userId ? ({
        id,
        userId,
        'User Code': userCode ? `JV2-${userCode}` : '',
        email,
        'Account Manager': managerName,
        name: `JV2-Support`,
        'First Name': name,
        'Last Name': lastName,
        'User Locker': userId ? `${config.baseUrl}admin/users/${userId}` : ''
      }) : ({
        id,
        userId,
        'User Code': 'Anonymous',
        name: `JV2-Support`
      }),
      options: {
        team_id: config.slaaskSupportTeam,
        pulse: true
      },
      key: config.slaaskSuuportKey
    }
    : {
      identify: () => ({
        id,
        name: `JV2-PRO ASSIST-${id}`,
        ticket: id,
        userId,
        email,
        'Account Manager': managerName,
        'User Locker': `${config.baseUrl}admin/users/${userId}`,
        'Name': `${name} ${lastName}`
      }),
      options: {
        team_id: config.slaaskTeam,
        pulse: true
      },
      onInit: _slaask => {
        _slaask.on('ready', () => {
          _slaask.show()
          setTimeout(() => {
            document.getElementById('slaask-widget').style.height = '620px'
          }, 100)
        })
        if (callBackMessage) {
          _slaask.on('sent_message', callBackMessage)
        }
      },
      key: config.slaaskApiKey
    }
  window._slaaskSettings = settings
  if (window._slaask) {
    window._slaask.identifyContact()
  } else {
    LoadScripts([
      { url: 'https://cdn.slaask.com/chat_loader.js', scriptId: 'slaask' }
    ])
  }
}

export function closeSlaask() {
  if (window._slaask) {
    window._slaask.destroy()
  }
}



// WEBPACK FOOTER //
// ./src/slaask.js